/*
  Statement date calculation is used for statement generation and email date handling
*/
import { DateTime } from 'luxon';

import { BillTiming } from '@willow/types-iso';

export const NEXT_STATEMENT_DAY_18 = 18;
export const NEXT_STATEMENT_DAY_1 = 1;

/**
 * If due on the 25th and HELOC or Construction loan, return 1st of the same month
 * If due on the 1st, return 18th of the previous month
 * If due on any other day, return 15 days before the payment due date
 */
export function getStatementDateForPaymentDue(paymentDueDate: Date, billTiming: BillTiming = 'fixed'): Date {
  const paymentDueDateTime = DateTime.fromJSDate(paymentDueDate);
  if (billTiming === 'fixed') {
    // HELOC and Construction loan logic is weird
    if (paymentDueDateTime.day === 25) {
      return DateTime.fromJSDate(paymentDueDate).set({ day: NEXT_STATEMENT_DAY_1 }).toJSDate();
    }
    if (paymentDueDateTime.day === 1) {
      return DateTime.fromJSDate(paymentDueDate).set({ day: NEXT_STATEMENT_DAY_18 }).minus({ months: 1 }).toJSDate();
    }
  }
  return DateTime.fromJSDate(paymentDueDate).minus({ days: 15 }).toJSDate();
}
